export const singleJointOptions = [
                  {
                    value: '1',
                    label: "Single",
                  },
                  {
                    value: '2',
                    label: "Joint",
                  }
                ]

export const accountTypeOptions = [
                  {
                    value: "1",
                    label: "Savings",
                  },
                  {
                    value: "2",
                    label: "Checking",
                  }
                ]

export const emptyFbarFatcaContext = {
    accountClosedYear: '',
    accountOpenedYear: '',
    bankMailingAddress : '',
    currency : '',
    dividendsIncome : '',
    fbarFatcaAccountNumber : '',
    fbarFatcaAccountType : '',
    fbarFatcaBankAccountType : '',
    fbarFatcaBankName : '',
    interestIncome : '',
    maxAccountBalance : '',
    nameOfAccountOwner : '',
    yearAccountBalance : '',
    jointAccountHolder : '',
    address : '',
    ssnItinNumber : '',
    relationship : '',
    noOfJointOwners : ''
}